var _path, _defs, _path2, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfMenuDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0.875,
    y: 2.625,
    width: 19.2478,
    height: 15.7482,
    viewBox: "0 0 19.2478 15.7482",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6231 0.8749H2.6247C1.65831 0.8749 0.8749 1.65831 0.8749 2.6247V13.1235C0.8749 14.0899 1.65831 14.8733 2.6247 14.8733H16.6231C17.5896 14.8733 18.3729 14.0899 18.3729 13.1235V2.6247C18.3729 1.65831 17.5896 0.8749 16.6231 0.8749Z",
    stroke: "url(#paint0_linear_0_13)",
    strokeWidth: 1.7498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_13",
    x1: 0.8749,
    y1: 7.87407,
    x2: 18.3729,
    y2: 7.87407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0.875,
    y: 5.25,
    width: 19.2481,
    height: 6.99582,
    viewBox: "0 0 19.2481 6.99582",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3731 0.87501L10.5252 5.86191C10.2551 6.03116 9.94275 6.12092 9.624 6.12092C9.30524 6.12092 8.99299 6.03116 8.72288 5.86191L0.87501 0.87501",
    stroke: "url(#paint0_linear_0_12)",
    strokeWidth: 1.7498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_12",
    x1: 0.87501,
    y1: 3.49797,
    x2: 18.373,
    y2: 3.49797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfMenuDoctor);
export default __webpack_public_path__ + "static/media/cf-menu-doctor.1172d1d3d926d112f6d2a2a71174f285.svg";
export { ForwardRef as ReactComponent };